module.exports = __webpack_public_path__ + "static/media/201B-1401B.fe134227.png";